import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"text-align":"right","margin":"0"} }
const _hoisted_7 = { style: {"color":"red","font-weight":"bolder","margin":"0"} }
const _hoisted_8 = { style: {"text-align":"right","margin":"0"} }
const _hoisted_9 = { style: {"color":"red","font-weight":"bolder","margin":"0"} }
const _hoisted_10 = { style: {"text-align":"right","margin":"0"} }
const _hoisted_11 = { class: "dialog_box" }
const _hoisted_12 = { style: {"text-align":"right","margin":"0"} }
const _hoisted_13 = { style: {"color":"red","font-weight":"bolder","margin":"0"} }
const _hoisted_14 = { style: {"color":"red","font-weight":"bolder","margin":"0"} }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "dialog-footer" }

import { ref, reactive } from 'vue'
    import { Tool } from '@/util/tool'
    import { FormInstance, FormRules, ElMessage } from 'element-plus'
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

    const formRef = ref<FormInstance>()
    const isLoading = ref<boolean>(false)
    const dialogVisible = ref<boolean>(false)
    const certificates = ref<any>([])
    const certificate = ref<any>({})
    const isEmpty = ref<boolean>(false)
    const tips = ref<string>('')
    const line = ref<number>(1)
    const dialogWidth = ref<number>(800)

    if ( Tool.isMobile() ) {
        line.value = 1
        dialogWidth.value = 380
    } else {
        line.value = 2
        dialogWidth.value = 800
    }

    const formatTips = (key: string) => {
      if ( key === 'C_TSJ_201' ) {
        return '本证书须每年接受再培训，考试合格后重新下载证书。'
      } else if ( key === 'C_TSJ_511' ) {
        return '本证书须每3年接受再培训，考试合格后重新下载证书。'
      } else {
        return '本证书须每年接受继续教育，考试合格后重新下载证书。'
      }
    }

    const rules = reactive<FormRules>({
        studenName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idcardCode: [
            { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        idcardNo: [
            { required: true, message: '请输入证件号码', trigger: 'blur' }
        ],
        code: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
    })

    const userForm = reactive({
        studenName: null,
        idcardCode: null,
        idcardNo: null,
        code: null,
    })

    const types = ref([
        {label: '身份证', value: '1'},
        {label: '港澳台胞证', value: '2'},
        {label: '护照', value: '3'},
    ])
    
    const setTypeOne  = (code: string ) => {
        if ( code === 'C_TSJ_201' || code === 'C_TSJ_101' || code === 'C_TSJ_502' ) {
          return '行业类别';
        } else if ( code === 'C_TSJ_420' || code === 'C_TSJ_419' ) {
          return '单位类别';
        } else {
          return '作业类别';
        }
    }

    const checkType = (code: string) => {
      if ( code === 'C_TSJ_201' || code === 'C_TSJ_101' || code === 'C_TSJ_102' || code === 'C_TSJ_120' || code === 'C_TSJ_103' || code === 'C_TSJ_104' || code === 'C_TSJ_502' || code === 'C_TSJ_501' ) {
        return true
      } else {
        return false
      }
    }

    const checkTType = (code: string) => {
      // if ( code === 'C_TSJ_420' || code === 'C_TSJ_419' ) {
      //   return true
      // } else {
      //
      // }
      return false
    }

    const setTypeTwo = (code: string) => {
        if ( code === 'C_TSJ_201' || code === 'C_TSJ_101' || code === 'C_TSJ_502' ) {
            return '人员类别';
        } else {
            return '操作项目';
        }
    }

    const onSubmit = (formEl: FormInstance | undefined) => {
        if (!formEl) return
        formEl.validate((valid:any) => {
            if (valid) {
                queryCertificate()
            } else {
                console.log('error submit!')
                return false
            }
        })
    }

    const downLoad = async (row:any) => {
        row.loading = true
        let res = await axios.get('/api/certificate/download/'+row.id);
        row.loading = false
        if ( res.data.code === 200 ) {
            location.href = '/api/common/download?fileName='+res.data.msg
        } else {
            ElMessage.error(res.data.msg)
        }
    }

    const queryCertificate = async () => {
        let params = userForm
        isLoading.value = true
        let res = await axios.get('/api/certificate/list', { params });
        isLoading.value = false
        resetImg()
        if ( res.data.code === 200 ) {
            dialogVisible.value = true
            let { data: { records } } = res.data
            if ( records.length > 0 ) {
                isEmpty.value = true
                certificate.value = records
                certificates.value = []
            } else {
                isEmpty.value = false
            }
        } else {
            ElMessage.error(res.data.msg)
        }
    }

    const kaptchaUrl = ref('')
    const resetImg = () => {
        let time = new Date().getTime()
        let url = `/api/common/kaptcha?t=${time}`
        kaptchaUrl.value = url
        userForm.code = ''
    }

    const resetForm = (formEl: FormInstance | undefined) => {
        if (!formEl) return
        formEl.resetFields()
    }

    const handleClose = () => {
        dialogVisible.value = false
    }

    resetImg()


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Refresh = _resolveComponent("Refresh")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("h1", null, "安全生产和职业健康培训信息查询及电子证下载", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: userForm,
            rules: rules,
            "label-width": "80px",
            "scroll-to-error": true,
            "status-icon": "",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "姓名",
                prop: "studenName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: userForm.studenName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userForm.studenName) = $event)),
                    clearable: "",
                    placeholder: "请输入姓名"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "证件类型",
                prop: "idcardCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: userForm.idcardCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userForm.idcardCode) = $event)),
                    style: {"width":"100%"},
                    clearable: "",
                    placeholder: "请输入证件类型"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "证件号码",
                prop: "idcardNo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: userForm.idcardNo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userForm.idcardNo) = $event)),
                    clearable: "",
                    placeholder: "请输入证件号码"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "验证码",
                prop: "code"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: userForm.code,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userForm.code) = $event)),
                        clearable: "",
                        placeholder: "请输入验证码"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 8,
                    style: {"display":"flex","align-items":"center"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        style: {"height":"40px","margin":"0 5px"},
                        onClick: resetImg,
                        src: kaptchaUrl.value
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "success",
                        style: {"width":"100%"},
                        size: "mini",
                        onClick: resetImg
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Refresh)
                            ]),
                            _: 1
                          }),
                          _cache[8] || (_cache[8] = _createTextVNode("更换 ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    loading: isLoading.value,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (onSubmit(formRef.value)))
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("查询", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"]),
                  _createVNode(_component_el_button, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (resetForm(formRef.value)))
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("重置", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "right" }, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, "1."),
            _createTextVNode("查询范围：本平台提供由昆山大明培训机构按照国家规定经专门的安全生产和职业健康培训，取得《安全培训合格证》、《职业健康培训合格证》信息查询。")
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", null, "2."),
            _createTextVNode("数据时间：本平台中数据从2023年开始，2023年度考试合格后24小时可查询培训信息及电子证下载。")
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("span", null, "3."),
            _createTextVNode("相关说明：本平台中数据由昆山大明培训机构提供，如对查询结果存有疑问，请与大明培训机构联系。")
          ])
        ], -1))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogVisible).value = $event)),
      title: "查询结果",
      width: dialogWidth.value,
      "before-close": handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_16, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (isEmpty.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certificate.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  style: {"margin":"8px 0"},
                  key: index
                }, [
                  (checkTType(item.subjectCode))
                    ? (_openBlock(), _createBlock(_component_el_descriptions, {
                        key: 0,
                        direction: "horizontal",
                        column: line.value,
                        border: "",
                        width: 140
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_descriptions_item, {
                            label: "姓名",
                            span: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.studenName), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.certNo), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.gender === '1' ? '男' : '女'), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (item.idcardNo !== item.certNo)
                            ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                key: 0,
                                label: "初领日期"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.createDate), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_descriptions_item, {
                            span: 2,
                            label: "证件号"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.idcardNo), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_descriptions_item, {
                            span: 4,
                            label: setTypeOne(item.subjectCode)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.subjectName), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            span: 4,
                            label: setTypeTwo(item.subjectCode)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.positionType), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            width: "80px",
                            label: "操作",
                            span: 4
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_6, [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  loading: item.loading,
                                  onClick: ($event: any) => (downLoad(item))
                                }, {
                                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode("下载电子证书", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["loading", "onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["column"]))
                    : (checkType(item.subjectCode))
                      ? (_openBlock(), _createBlock(_component_el_descriptions, {
                          key: 1,
                          direction: "horizontal",
                          column: line.value,
                          border: "",
                          width: 140
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_descriptions_item, {
                              label: "姓名",
                              span: 4
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.studenName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.certNo), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.gender === '1' ? '男' : '女'), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (item.idcardNo !== item.certNo)
                              ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                  key: 0,
                                  label: "初领日期"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.createDate), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_descriptions_item, { label: "证件号" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.idcardNo), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, {
                              label: setTypeOne(item.subjectCode)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.subjectName), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]),
                            _createVNode(_component_el_descriptions_item, { label: "最近再培训记录" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.nextTime1), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, {
                              label: setTypeTwo(item.subjectCode)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.positionType), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]),
                            _createVNode(_component_el_descriptions_item, {
                              label: "说明",
                              span: 4
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_7, _toDisplayString(formatTips(item.subjectCode)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, {
                              width: "80px",
                              label: "操作",
                              span: 4
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_8, [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    loading: item.loading,
                                    onClick: ($event: any) => (downLoad(item))
                                  }, {
                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                      _createTextVNode("下载电子证书", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["loading", "onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["column"]))
                      : (!checkType(item.subjectCode))
                        ? (_openBlock(), _createBlock(_component_el_descriptions, {
                            key: 2,
                            direction: "horizontal",
                            column: line.value,
                            border: "",
                            width: 140
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_descriptions_item, {
                                label: "姓名",
                                span: 4
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.studenName), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.certNo), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.gender === '1' ? '男' : '女'), 1)
                                ]),
                                _: 2
                              }, 1024),
                              (item.idcardNo !== item.certNo)
                                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                    key: 0,
                                    label: "初领日期"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.createDate), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_descriptions_item, { label: "证件号" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.idcardNo), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_descriptions_item, {
                                label: setTypeOne(item.subjectCode)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.subjectName), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]),
                              _createVNode(_component_el_descriptions_item, { label: "最近再培训记录" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.nextTime1), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_descriptions_item, {
                                label: setTypeTwo(item.subjectCode)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.positionType), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]),
                              _createVNode(_component_el_descriptions_item, {
                                label: "说明",
                                span: 4
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_9, _toDisplayString(formatTips(item.subjectCode)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_descriptions_item, {
                                width: "80px",
                                label: "操作",
                                span: 4
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_10, [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      loading: item.loading,
                                      onClick: ($event: any) => (downLoad(item))
                                    }, {
                                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                        _createTextVNode("下载电子证书", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["loading", "onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["column"]))
                        : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createVNode(_component_el_divider, { style: {"margin":"20px 0"} }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("历史考证记录", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certificates.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item",
                    style: {"margin":"8px 0"},
                    key: index
                  }, [
                    (checkTType(item.subjectCode))
                      ? (_openBlock(), _createBlock(_component_el_descriptions, {
                          key: 0,
                          direction: "horizontal",
                          column: line.value,
                          border: "",
                          width: 140
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_descriptions_item, {
                              label: "姓名",
                              span: 4
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.studenName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, {
                              label: "证书编号",
                              span: 4
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.certNo), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.gender === '1' ? '男' : '女'), 1)
                              ]),
                              _: 2
                            }, 1024),
                            (item.idcardNo !== item.certNo)
                              ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                  key: 0,
                                  label: "初领日期"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.createDate), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_descriptions_item, {
                              span: 2,
                              label: "证件号"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.idcardNo), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_descriptions_item, {
                              span: 4,
                              label: setTypeOne(item.subjectCode)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.subjectName), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]),
                            _createVNode(_component_el_descriptions_item, {
                              span: 4,
                              label: setTypeTwo(item.subjectCode)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.positionType), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]),
                            _createVNode(_component_el_descriptions_item, {
                              width: "80px",
                              label: "操作",
                              span: 4
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_12, [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    loading: item.loading,
                                    onClick: ($event: any) => (downLoad(item))
                                  }, {
                                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                      _createTextVNode("下载电子证书", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["loading", "onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["column"]))
                      : (checkType(item.subjectCode))
                        ? (_openBlock(), _createBlock(_component_el_descriptions, {
                            key: 1,
                            direction: "horizontal",
                            column: line.value,
                            border: "",
                            width: 140
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_descriptions_item, {
                                label: "姓名",
                                span: 4
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.studenName), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.certNo), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.gender === '1' ? '男' : '女'), 1)
                                ]),
                                _: 1
                              }),
                              (certificate.value.idcardNo !== certificate.value.certNo)
                                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                    key: 0,
                                    label: "初领日期"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(certificate.value.createDate), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_descriptions_item, { label: "证件号" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.idcardNo), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                label: setTypeOne(certificate.value.subjectCode)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.subjectName), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_descriptions_item, { label: "最近再培训记录" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.nextTime1), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                label: setTypeTwo(certificate.value.subjectCode)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.positionType), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_descriptions_item, {
                                label: "说明",
                                span: 4
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_13, _toDisplayString(formatTips(certificate.value.subjectCode)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["column"]))
                        : (!checkType(item.subjectCode))
                          ? (_openBlock(), _createBlock(_component_el_descriptions, {
                              key: 2,
                              direction: "horizontal",
                              column: line.value,
                              border: "",
                              width: 140
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_descriptions_item, {
                                  label: "姓名",
                                  span: 4
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.studenName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.certNo), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.gender === '1' ? '男' : '女'), 1)
                                  ]),
                                  _: 1
                                }),
                                (certificate.value.idcardNo !== certificate.value.certNo)
                                  ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                      key: 0,
                                      label: "初领日期"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(certificate.value.createDate), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_descriptions_item, {
                                  label: setTypeOne(certificate.value.subjectCode)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.subjectName), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_descriptions_item, {
                                  label: setTypeTwo(certificate.value.subjectCode)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.positionType), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_descriptions_item, { label: "最近再培训记录" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.nextTime1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, {
                                  label: "说明",
                                  span: 4
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_14, _toDisplayString(formatTips(certificate.value.subjectCode)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["column"]))
                          : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_el_empty, { description: "未查到相关证书" })
            ]))
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ]))
}
}

})